// extracted by mini-css-extract-plugin
module.exports = {"languageSelector":"LanguageSelector_languageSelector__USENg","languageSelectorIcon":"LanguageSelector_languageSelectorIcon__fy0XJ"};